import React, { useState, useEffect } from "react";
import Switch from "@material-ui/core/Switch";
import { Modal } from "react-bootstrap";
import { Multiselect } from "multiselect-react-dropdown";
import BackspaceIcon from "@material-ui/icons/Backspace";
import UpdateOutlinedIcon from "@material-ui/icons/UpdateOutlined";
import { Tooltip } from "@material-ui/core";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { loader } from "../../../Actions/index";
import { ToastSuccess, ToastError } from "../../../component/toast-notification.js";
import {
  GetSingleDeHub,
  UpdateDeHubActiveStatus,
  updateDeHubManager,
  updateDeHubActiveOpenStatus,
} from "../../../api/apiService";

const HubDetailsInfo = ({ hubId }) => {
  const dispatch = useDispatch();
  const loaderDisplay = useSelector(state => state.loaderDisplay);
  
  const [de_hub, setOutlet] = useState({});
  const [isActive, setIsActive] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [status, setStatus] = useState({ restaurant: "", breakTime: "", closingTime: "", breakStart: "", breakEnd: "" });
  const [modal, setModal] = useState({ show: false, type: "", submitted: false });
  const [complimentary, setComplimentary] = useState({ all: [], selected: "" });
  const [mobileNo, setMobileNo] = useState("");

  const now = moment();
  const today = now.format("YYYY-MM-DD");
  const currentTime = now.format("HH:mm");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [de_hubRes] = await Promise.all([
        GetSingleDeHub(hubId),
      ]);
      
      const de_hubData = de_hubRes.data.data;
      setOutlet(de_hubData);
      setIsActive(de_hubData.isActive);
      setIsOpen(de_hubData.isOpen);
      
      calculateStatus(de_hubData);
    } catch (error) {
      console.error(error);
      ToastError(error.response?.data?.message || "Failed to fetch data");
    }
  };

  const calculateStatus = (de_hubData) => {
    const { opening_time, closing_time, break_start, break_end } = de_hubData;
    
    // Restaurant status
    const restaurantStatus = (currentTime > opening_time && currentTime < closing_time) ? "open" : "closed";
    
    // Closing time calculation
    const closingMoment = moment(`${today} ${closing_time}`);
    const duration = moment.duration(closingMoment.diff(now));
    const hours = Math.floor(duration.asHours());
    const minutes = Math.floor(duration.asMinutes() % 60);
    const closingTime = `${hours}:${minutes}`;
    
    // Break time calculation
    const breakStartMoment = moment(`${today} ${break_start}`);
    const breakEndMoment = moment(`${today} ${break_end}`);
    const breakStartDuration = moment.duration(breakStartMoment.diff(now)).format("hh:mm:ss");
    const breakEndDuration = moment.duration(breakEndMoment.diff(now)).format("hh:mm:ss");
    
    let breakStatus = "";
    if (currentTime <= break_start) breakStatus = "breakstart";
    else if (currentTime > break_start && currentTime < break_end) breakStatus = "breakin";
    else if (currentTime >= break_end) breakStatus = "breakclose";
    
    setStatus({
      restaurant: restaurantStatus,
      breakTime: breakStatus,
      closingTime,
      breakStart: breakStartDuration,
      breakEnd: breakEndDuration
    });
  };

  const handleModal = (type = "") => {
    setModal(prev => ({ ...prev, show: !prev.show, type, submitted: false }));
  };

  const handleInputChange = (value, field) => {
    if (field === "mobile") {
      setMobileNo(value);
    } else if (field === "complimentary") {
      setComplimentary(prev => ({ ...prev, selected: value }));
    }
    if (modal.submitted) validate();
  };

  const validate = () => {
    if (modal.type === "manager") return mobileNo.length === 10;
    if (modal.type === "complimentary") return complimentary.selected !== "";
    return true;
  };

  const handleSubmit = async () => {
    setModal(prev => ({ ...prev, submitted: true }));
    if (!validate()) return;

    try {
      if (modal.type === "manager") {
        dispatch(loader(true));
        await updateDeHubManager(hubId, { mobile: mobileNo });
        setMobileNo("");
        dispatch(loader(false));
      } 
      
      handleModal();
      fetchData();
      ToastSuccess("Operation completed successfully");
    } catch (error) {
      console.error(error);
      ToastError(error.response?.data?.message || "Operation failed");
      if (modal.type === "manager") dispatch(loader(false));
    }
  };

  const handleStatusChange = async (type) => {
    try {
      if (type === "active") {
        await UpdateDeHubActiveStatus(hubId);
        setIsActive(!isActive);
      } else {
        await updateDeHubActiveOpenStatus(hubId);
        setIsOpen(!isOpen);
      }
      ToastSuccess("Status updated successfully");
      window.location.reload();
    } catch (error) {
      console.error(error);
      ToastError(error.response?.data?.message || "Failed to update status");
    }
  };

  // const deleteComplimentary = async () => {
  //   if (!window.confirm("Do you want to delete the complimentaries?")) return;
    
  //   try {
  //     await deleteDeHubCompliment(de_hub._id, "de_hub");
  //     ToastSuccess("Complimentary deleted successfully");
  //     fetchData();
  //   } catch (error) {
  //     console.error(error);
  //     ToastError(error.response?.data?.message || "Failed to delete complimentary");
  //   }
  // };

  if (!de_hub._id) return <div></div>;

  return (
    <>
      <div className="category-container my-3">
        <div className="resturent-details-container">
          <div className="row">
            <div className="col-md-7">
              <div className="row">
                <div className="col-md-5">
                  <div className="details-img-container">
                    <img src={de_hub.De_Hub_images} alt="" />
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="bg-white p-2">
                    <p className="resturent-name">{de_hub.hub_name}</p>
                    
                    {de_hub.isActive && (
                      <>
                        <div className="d-flex align-items-center mb-2">
                          <div className={`tag-icon ${status.restaurant === "open" ? "success-badge" : "danger-badge"} mr-1`}>
                            <UpdateOutlinedIcon />
                          </div>
                          <div>
                            {status.restaurant === "open" ? (
                              <span style={{ color: "#32c975" }}>Close in {status.closingTime} hours</span>
                            ) : (
                              <span style={{ color: "#ffa54e" }}>Closed</span>
                            )}
                          </div>
                        </div>
                        
                        <div className="d-flex align-items-center mb-2">
                          {status.breakTime === "breakin" && (
                            <div className="tag-icon danger-badge mr-1">
                              <UpdateOutlinedIcon />
                            </div>
                          )}
                          <div>
                            {status.breakTime === "breakstart" && (
                              <span style={{ color: "#ffa54e" }}>Break Start in {status.breakStart}</span>
                            )}
                            {status.breakTime === "breakin" && (
                              <span style={{ color: "#ffa54e" }}>Now break time, Reopen in {status.breakEnd}</span>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    
                    <p className="resturent-address">{de_hub.address_details?.address}</p>
                    
                    <div className="row align-items-center">
                      {/* <div className="col-lg-6 col-12">
                        <span className="font-12 font-weight-bold">Cost For Two ₹{de_hub.cost_for_two}</span>
                      </div> */}
                      <div className="col-lg-6 col-12">
                        <div>
                          <span className="font-12 font-weight-bold">Active / Deactive</span>
                          <Switch
                            checked={isActive}
                            onChange={() => handleStatusChange("active")}
                            name="checkedOutletActive"
                            inputProps={{ "aria-label": "primary checkbox" }}
                          />
                        </div>
                        {de_hub.isActive && (
                          <div>
                            <span className="font-12 font-weight-bold">Open / Closed</span>
                            <Switch
                              checked={isOpen}
                              onChange={() => handleStatusChange("open")}
                              name="isOpen"
                              inputProps={{ "aria-label": "primary checkbox" }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {de_hub.isActive && (
              <div className="col-md-5">
                <div>
                  {["Restaurant", "Delivery", "Break"].map((type, index) => {
                    const times = [
                      { start: de_hub.opening_time, end: de_hub.closing_time },
                      { start: de_hub.delivery_start_time, end: de_hub.delivery_end_time },
                      { start: de_hub.break_start, end: de_hub.break_end }
                    ];
                    
                    return (
                      <div key={type} className="resturent-time-box mr-2">
                        <p className="resturent-time-title">{type} Time</p>
                        <div className="d-flex">
                          <div className="resturent-time success-badge mr-2">
                            <span className="time-type">{type === "Break" ? "Start" : type === "Restaurant" ? "Open" : "Start"}</span>
                            <span className="time">{times[index].start}</span>
                          </div>
                          <div className="resturent-time danger-badge">
                            <span className="time-type">{type === "Break" ? "End" : type === "Restaurant" ? "Close" : "End"}</span>
                            <span className="time">{times[index].end}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                
                <div className="d-flex justify-content-start align-items-end flex-wrap">
                  <div>
                    <p className="text-capitalize">
                      <b>{de_hub.manager?.full_name || ""}</b>
                    </p>
                    <button
                      onClick={() => handleModal("manager")}
                      type="button"
                      className={de_hub.manager ?"btn btn-warning":"btn btn-primary"}
                    >
                      {de_hub.manager ? "Change manager" : "Add manager"}
                    </button>
                  </div>
                  
                  <div className="m-2"></div>
                  
                  {/* <div>
                    <div>
                      {de_hub.complementary && de_hub.complementary !== "null" && (
                        <span className="text-capitalize badge bg-light text-dark font-15 my-2">
                          {de_hub.complementary.name}
                          <Tooltip title="Delete complimentary" placement="right" arrow>
                            <BackspaceIcon
                              // onClick={deleteComplimentary}
                              style={{ fontSize: "16px", color: "red", cursor: "pointer", marginLeft: "3px" }}
                            />
                          </Tooltip>
                        </span>
                      )}
                    </div>
                    <button
                      onClick={() => handleModal("complimentary")}
                      type="button"
                      className="btn btn-verify"
                    >
                      {de_hub.complementary && de_hub.complementary !== "null" ? "Change" : "Add"} complimentary
                    </button>
                  </div> */}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal show={modal.show} onHide={handleModal} backdrop="static" size="sm" keyboard={false} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>{modal.type === "manager" ? "Manager" : "Complimentary"}</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modal.type === "manager" ? (
            <>
            <div>
              <p>Current Manager: <b className="text-secondary">{de_hub.manager?.full_name || ""}</b></p>
            </div>
              <div className="form-group m-0">
                <label className="font-12 m-0">Mobile no</label>
                <input
                  onChange={(e) => handleInputChange(e.target.value, "mobile")}
                  style={mobileNo.length !== 10 && modal.submitted ? { border: "1px solid red" } : {}}
                  type="number"
                  value={mobileNo}
                  className="form-control"
                  placeholder="Enter mobile number"
                />
              </div>
              <div className="text-right mt-2">
                <button onClick={handleSubmit} type="button" className="btn btn-verify">
                  Add
                </button>
              </div>
            </>
          ) : (
            <>
              <div
                className="category-field mb-2"
                style={
                  complimentary.selected === "" && modal.submitted
                    ? { border: "1px solid red", borderRadius: "4px" }
                    : { border: "1px solid #cccccc", borderRadius: "4px" }
                }
              >
                <Multiselect
                  isObject={true}
                  onRemove={() => handleInputChange("", "complimentary")}
                  onSelect={(value) => handleInputChange(value[0]._id, "complimentary")}
                  options={complimentary.all}
                  displayValue="name"
                  placeholder="Select complimentaries"
                  selectionLimit={1}
                  closeOnSelect={true}
                />
              </div>
              <div className="text-right my-3">
                <button onClick={handleSubmit} type="button" className="btn btn-verify">
                  Add For Outlet
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default HubDetailsInfo;